// Node
import GuestsWidget from "../../../common/search_widget/guests";
import {popupOpenInit} from "../popup";
import i18next from "i18next";

const $ = require('jquery');

class GuestsWidgetMobile extends GuestsWidget {
  build (formId, options) {
    this.$form = $(formId);
    this.$childrenAges      =  $(options.childrenAges);
    this.$childrenCount    =  $(options.childrenCount);
    this.$countGuests      =  $(options.countGuests);
    this.$totalAdultsCount      =  $(options.totalAdultsCount);
    this.$totalChildrenCount      =  $(options.totalChildrenCount);
    this.$guestChildNumber =  $(options.guestChildNumber);
    this.doInitPopupOpen = options.doInitPopupOpen === undefined ? true : options.doInitPopupOpen;
    this.afterChildInputCreate = options.afterChildInputCreate;
    this.$form.find('.popup-submit').click(options.onUpdate);
  }

  _childBlock(age = parseInt(this.$childrenAges.attr('default_age')), count, childrenAges) {
    return `
      <div class="guest-child__input-item">
        <div class="ui-select margin-bottom-16 open_popup guest-child__input-item_open_popup" rel="${$(childrenAges).attr('prefix') || ''}guest-child-number">
          <span class="ui-select__label">Возраст ${count}-го ребенка</span>
          <span class="ui-select__value">${i18next.t('age', { count: age })}</span>
          <input name="children_ages[]" type="hidden" value="${age}">
        </div>
      </div>
    `;
  }

  _initMobilePopupAges() {
    if (this.doInitPopupOpen) {
      popupOpenInit();
      $('.guest-child__input-item').on('click', function () {
        $(this).addClass('activated');
      });
    }
    if (this.afterChildInputCreate) this.afterChildInputCreate();
  }

  _setGuestsCount(adult, child) {
    if (adult) {
      let guests = adult;
      if (child) guests += child;
      $('.search-params__guests').text(i18next.t('guest', { count: guests }));
    }
  }

  _initTotalCountBtns() {
    let widget = this;
    this.$form.find('.more, .less').on('click', function () {
      if ($(this).hasClass('guest-line__count-btn_disable')) {
        return;
      }
      let guests_field = $(`.${$(this).attr('target_input')}`);
      let maxCount = parseInt(guests_field.attr('max'));
      let minCount = parseInt(guests_field.attr('min')) || 0;
      let oldVal = parseInt(guests_field.val());
      let newVal = oldVal;

      if ($(this).hasClass('more') && oldVal < maxCount) {
        newVal = oldVal + 1;
      } else if ($(this).hasClass('less') && oldVal > minCount) {
        newVal = oldVal - 1;
      }
      guests_field.each(function () {
        $(this).val(newVal);
        $(this).trigger('change');
      })
      $(this).parent().find('.guest-line__count-numb').text(newVal);
      widget.syncInflection();

      if (newVal === minCount) {
        $(this).parent().children('.less').addClass('guest-line__count-btn_disable');
      } else if (newVal === maxCount) {
        $(this).parent().children('.more').addClass('guest-line__count-btn_disable');
      } else {
        $(this).parent().children('.less').removeClass('guest-line__count-btn_disable');
        $(this).parent().children('.more').removeClass('guest-line__count-btn_disable');
      }
    });
  }

  _initMobilePopdownAges() {
    let widget = this;

    $('.input-popup-down__select').on('click', function () {
      let $inputItem = widget.$form.find('.guest-child__input-item.activated');
      let $valueText = $inputItem.find('.ui-select__value');
      let index = $inputItem.parent().find('.guest-child__input-item').index($inputItem);
      let val = $(this).val();
      widget.$childrenAges.each(function () {
        $(this).find('input').eq(index).val(val);
      })
      $valueText.text($(this).text());
      $inputItem.removeClass('activated');
    });
  }

}

export default GuestsWidgetMobile;
